import React, { useState } from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import { ReactComponent as SearchIcon } from "../Assets/Icons/search.svg";
import FilterICon from "../Assets/Icons/filterIcon.svg";
import EmptyComponent from "../Components/EmptyComponent";

export default function PeopleEmpty() {
  return (
    <DashboardLayout>
      <section className="bg-white pl-6 py-4 gap-y-5 w-full flex flex-col items-start">
        <Breadcrumbs links={[{ name: "Search People", link: "dsads" }]} />
        <h1 className="text-xl font-semibold">Search People</h1>
        <div className="flex items-center gap-4">
          <div className="flex items-center ">
            <div className="rounded-l-lg border flex items-center py-2 px-3 bg-[#F9FAFB] w-[23rem]">
              <SearchIcon />
              <input
                type="text"
                placeholder="Search people"
                className="border-none ml-2 bg-inherit w-full text-sm font-medium text-[#6B7280] focus:outline-none"
              />
            </div>
            <div>
              <button className="w-[4.4rem] py-2 px-2 text-[0.95rem] font-[500] text-white rounded-r-lg bg-[#942A27]">
                Search
              </button>
            </div>
          </div>
          <div className="relative">
            <button
              className="w-[5.6rem] h-[2.3rem] flex items-center justify-center border-[1px] border-[#E5E7EB] rounded-[8px] gap-2"
            >
              <img src={FilterICon} /> Filters
            </button>
          </div>
        </div>
      </section>
      <section className="bg-[#f9fafb] w-full h-screen pt-6 px-7 pb-8">
        <div>
          <p className="text-[1rem] font-bold text-[#6B7280]">
            All Teams: <span className="text-[#111928]">0</span>
          </p>
        </div>
        <div className="flex items-center justify-center h-full">
        <div className="w-[30%]">
            <EmptyComponent title='The Al People Folder is empty.' text='Populate your Al ecosystem by encouraging your colleagues to build their individual profile.' />
        </div>
        </div>
      </section>
    </DashboardLayout>
  );
}
